<template>
  <div class="min-h-screen relative overflow-hidden">
    <!-- Animierter Background -->
    <div class="fixed inset-0 -z-10">
      <!-- Gradient Background -->
      <div class="absolute inset-0 bg-gradient-to-br from-gray-50 via-blue-50/30 to-gray-100 dark:from-gray-900 dark:via-blue-950/20 dark:to-gray-800"></div>

      <!-- Animierte Gradient Blobs -->
      <div class="absolute top-0 -left-4 w-96 h-96 bg-blue-400/20 dark:bg-blue-500/10 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-3xl opacity-70 animate-blob"></div>
      <div class="absolute top-0 -right-4 w-96 h-96 bg-purple-400/20 dark:bg-purple-500/10 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-3xl opacity-70 animate-blob animation-delay-2000"></div>
      <div class="absolute -bottom-8 left-20 w-96 h-96 bg-pink-400/20 dark:bg-pink-500/10 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-3xl opacity-70 animate-blob animation-delay-4000"></div>

      <!-- Grid Pattern Overlay -->
      <div class="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px] dark:bg-[linear-gradient(to_right,#ffffff08_1px,transparent_1px),linear-gradient(to_bottom,#ffffff08_1px,transparent_1px)]"></div>
    </div>

    <Navigation />

    <!-- Sections -->
    <HeroSection />

    <ServicesSection />

    <PortfolioSection
      :projects="portfolioProjects"
      :loading="loadingProjects"
    />

    <TestimonialsSection />

    <ContactSection />

    <StandardFooter />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import Navigation from '../components/Navigation.vue'
import HeroSection from '../components/home/HeroSection.vue'
import PortfolioSection from '../components/home/PortfolioSection.vue'
import ServicesSection from '../components/home/ServicesSection.vue'
import TestimonialsSection from '../components/home/TestimonialsSection.vue'
import ContactSection from '../components/home/ContactSection.vue'

// Lazy-load Firebase-Funktionen, um initiales Bundle zu reduzieren
import type { PortfolioProject } from '../firebase/portfolio'
import StandardFooter from '../components/StandardFooter.vue'
import { logger } from '../utils/logger'

// State
const portfolioProjects = ref<PortfolioProject[]>([])
const loadingProjects = ref(false)

onMounted(async () => {
  loadingProjects.value = true
  try {
    // Lazy-load Firebase portfolio module
    const { getPortfolioProjects } = await import('../firebase/portfolio')
    const firebaseProjects = await getPortfolioProjects()
    // Dynamischer Import fuer besseres Code-Splitting
    const { combinePortfolioProjects } = await import('../utils/portfolioHelper')
    // Kombiniere Firebase-Projekte mit automatisch erkannten Projektseiten
    portfolioProjects.value = await combinePortfolioProjects(firebaseProjects)
  } catch (error) {
    logger.error('Portfolio load error', error)
  } finally {
    loadingProjects.value = false
  }
})
</script>

<style scoped>
@keyframes blob {
  0% { transform: translate(0px, 0px) scale(1); }
  33% { transform: translate(30px, -50px) scale(1.1); }
  66% { transform: translate(-20px, 20px) scale(0.9); }
  100% { transform: translate(0px, 0px) scale(1); }
}
.animate-blob {
  animation: blob 7s infinite;
}
.animation-delay-2000 {
  animation-delay: 2s;
}
.animation-delay-4000 {
  animation-delay: 4s;
}
</style>
